A candidate's response to a question in the questionnaire.
